// modules
import * as R from 'ramda'
import { v4 as uuidv4 } from 'uuid'
import { getSocket } from './socket'

const getPool = (() => {
  const pool = {}

  return {
    add: (uuid, resolve, reject, timer) => {
      pool[uuid] = { resolve, reject, timer }
    },

    resolve: (uuid, response) => {
      const val = pool[uuid]
      if (val) {
        if (val.timer) clearTimeout(val.timer)
        val.resolve(response)
        delete pool[uuid]
      }
    },

    onTimeout: uuid => {
      pool[uuid].reject(Error('Timeout'))
      delete pool[uuid]
    },

    resetTimers: () => {
      Object.keys(pool).forEach(key => {
        const { reject, timer } = pool[key]
        if (timer) {
          clearTimeout(timer)
          reject(Error('Reset'))
          delete pool[key]
        }
      })
    },
  }
})()

export const { resetTimers } = getPool

export const handleWsGet = action => {
  const uuid = R.path(['meta', 'uuid'], action)
  if (uuid) {
    getPool.resolve(uuid, action)
    return true
  }
  return false
}

export const wsGetNow = (action, timeout = 30000) =>
  new Promise((resolve, reject) => {
    const socket = getSocket()
    if (!socket.isOpen()) {
      reject(Error('Offline'))
      return
    }

    const uuid = uuidv4()
    const finalAction = R.assocPath(['meta', 'uuid'], uuid, action)
    socket.send(JSON.stringify(finalAction))

    const timer = setTimeout(getPool.onTimeout, timeout, uuid)

    getPool.add(uuid, resolve, reject, timer)
  })

export const wsGetCreator = send => (action, options) =>
  new Promise(resolve => {
    const uuid = uuidv4()
    const finalAction = R.assocPath(['meta', 'uuid'], uuid, action)
    send(finalAction, options)

    getPool.add(uuid, resolve)
  })
